<template>
  <div>

    <!-- Customers list --->
    <div
      class="p-3"
      v-show="currentStep === 'customers'"
    >
      <customer-stage-form v-model="customers" />

      <osv-app-alert
        :scrolling="false"
        osv-alert-position="osv-alert-relative"
        :direct-error="getCustomerLevelsErrors"
      />

      <div class="border-top text-right mt-4 pt-3">
        <b-button
          :disabled="customers.length === 0"
          :loading="loadingGetCustomersLevels"
          @click="getCustomerLevels"
          rounded
          class="is-primary"
        >
          Sélectionner les cours
        </b-button>
      </div>
    </div>

    <!-- Planner -->
    <div
      class="pt-3 planned-stages-list"
      v-show="currentStep === 'planner'"
    >
      <!-- Available re registration stages -->
      <div v-if="limitSlotRegistration && (registrationStagesByCustomers || []).length > 0">
        <div v-if="loadingReRegistration">
          <p class="text-center mb-3">
            Nous regardons les réinscriptions disponibles ...
          </p>
          <spinner />
        </div>
        <div v-else>
          <div>
            <stage-registration-list
              :registration-stages="registrationStagesByCustomers"
            />
          </div>
        </div>
      </div>

      <!-- Available stages -->
      <div v-else>
        <!-- Loading stages -->
        <div v-if="loadingGetAvailableStages">
          <p class="text-center mb-3">
            Récupération des cours ...
          </p>
          <spinner />
        </div>

        <div v-else>
          <div
            class="mt-5 mb-3"
            v-if="(registrationStagesByCustomers || []).length > 0 && (plannedStages || {}).length > 0"
          >
            <h2 class="is-size-4 text-underline">
              Les autres cours disponibles
            </h2>
          </div>

          <!-- Customers Summary -->
          <stage-customers-summary
            :customers-with-levels="customersWithLevels"
            :customers="customers"
            :planned-stages="plannedStages"
            :registration-stages-by-customers="registrationStagesByCustomers"
          />

          <!-- Planned stages list -->
          <div v-if="plannedStages.length > 0">
            <stages-list
              :planned-stages="plannedStages"
              :customers="customersWithLevels"
              :customers-by-planned-stages="customersByPlannedStages"
              :add-stage-to-customer="addStageToCustomer"
              :remove-stage-to-customer="removeStageToCustomer"
            />

            <!-- Start of summary part $ref -->
            <div ref="stageSummary" class="start-stage-summary-indicator" />

            <div
              v-if="stagesByCustomers.length > 0"
              class="planned-stages-summary-title"
              :class="allCustomersIsPlanned ? 'is-sticky-summary' : ''"
              @click="goToSummary"
            >
              <b-message type="is-success">
                <p class="is-size-5 has-text-weight-bold">
                  Récapitulatif de ma sélection <b-icon icon="chevron-down"/>
                </p>
              </b-message>
            </div>

            <div
              v-if="stagesByCustomers.length > 0"
              class="mt-5"
            >
              <customers-stages-list
                :stages-by-customers="stagesByCustomers"
                :remove-stage-to-customer="removeStageToCustomer"
              />
            </div>
          </div>
        </div>
      </div>

      <!-- If I have an error -->
      <osv-app-alert
        :scrolling="false"
        osv-alert-position="osv-alert-relative"
        :direct-error="addToBasketErrors"
      />

      <div class="mt-6 mb-4">
        <b-button
          rounded
          @click="swipeStep('previous')"
        >
          Annuler
        </b-button>
        <b-button
          :loading="loadingAddToCard"
          v-if="stagesByCustomers.length > 0"
          style="float: right"
          type="is-primary"
          rounded
          @click="addToBasket"
        >
          Ajouter au panier
        </b-button>
      </div>
    </div>
  </div>
</template>

<script>
import { ConfigMixin } from "@/mixins/ConfigMixin";
import CustomerStageForm from "@/components/partial/stagesPlanner/CustomerStageFrom";
import cug from "@/services/cug";
import Spinner from "@/components/shared/Spinner";
import StagesList from "@/components/partial/stagesPlanner/StagesList";
import CustomersStagesList from "@/components/partial/stagesPlanner/CustomersStagesList";
import store from "@/store";
import StageCustomersSummary from "@/components/partial/stagesPlanner/StageCustomersSummary";
import OsvAppAlert from "@/components/shared/OsvAppAlert";
import StageRegistrationList from "@/components/partial/stagesPlanner/StageRegistrationList.vue";

export default {
  store,
  name: 'StagesPlanner',
  components: {
    StageRegistrationList,
    OsvAppAlert,
    StageCustomersSummary,
    CustomersStagesList,
    StagesList,
    Spinner,
    CustomerStageForm
  },
  mixins: [ConfigMixin],

  data () {
    return {
      steps: ['customers', 'planner', 'confirmation'],
      currentStep: 'customers',
      customers: [],
      customersWithLevels: [],
      currentParticipations: [],

      plannedStages: [],
      registrationStagesByCustomers: null,

      customersByPlannedStages: {},
      stagesByCustomers: [],

      loadingGetCustomersLevels: false,
      loadingGetAvailableStages: true,
      loadingAddToCard: false,
      loadingReRegistration: false,
      limitSlotRegistration: false,

      allCustomersIsPlanned: false,

      getCustomerLevelsErrors: null,
      addToBasketErrors: null,
      tenant: null
    }
  },

  beforeMount () {
    this.getTenant();
  },

  methods: {
    getTenant () {
      cug
        .whoami()
        .then(resp => {
          this.tenant = resp.data;
          this.limitSlotRegistration = this.tenant.limit_slot_registration
        });
    },

    getCustomerLevels () {
      this.loadingGetCustomersLevels = true;
      this.customersByPlannedStages = {};
      this.customersWithLevels = [];
      this.currentParticipations = [];
      this.getCustomerLevelsErrors = null;

      cug
          .getCustomerLevels({
            customers: this.customers
          })
          .then((resp) => {
            let customerIndex = 0;
            for (const customer of resp.data) {
              let customerWithIndex = customer;
              customerWithIndex.customerIndex = customerIndex;
              this.customersWithLevels.push(customerWithIndex);
              if (customer.current_participant_ids.length > 0) {
                this.currentParticipations.push({ customer_id: customer.id, current_participant_ids: customer.current_participant_ids });
              }
              customerIndex++;
            }
            this.getCustomerLevelsErrors = null;

            // Get stages for re registration and all available stages
            if (this.currentParticipations.length > 0) {
              this.getReRegistrationStage().finally(() => { this.getAvailableStages(); });
            } else {
              // Get available stages if i don't have potential registration stages
              this.getAvailableStages();
            }

            this.swipeStep('next');
          })
          .catch((err) => {
            this.getCustomerLevelsErrors = { event: 'OsvAlert_ErrorFromApi', err: err, object: 'stage' };
          })
          .finally(() => {
            this.loadingGetCustomersLevels = false;
          })
    },

    getAvailableStages () {
      this.loadingGetAvailableStages = true;

      const data = {
        date: new Date,
        filters: []
      };

      for (const customer of this.customersWithLevels) {
        data.filters.push(
            {
              age: customer.projected_age.age,
              level_id: customer.level.id
            }
        )
      }

      cug
          .getAvailableStages(data)
          .then((resp) => {
            this.plannedStages = resp.data;
          })
          .finally(() => {
            this.loadingGetAvailableStages = false;
          })
    },

    async getReRegistrationStage () {
      new Promise((resolve, reject) => {
        this.loadingReRegistration = true;
        cug
            .getRegistrationStages({ filters: this.currentParticipations })
            .then((resp) => {
              this.registrationStagesByCustomers = resp.data;
              resolve(resp);
            })
            .catch((err) => {
              reject(err);
            })
            .finally(() => {
              this.loadingReRegistration = false;
            })
      })
    },

    addStageToCustomer (customer, plannedStage) {
      this.customersByPlannedStages[`planned-stage-${plannedStage.id}`] ||= {
        customers: {},
        plannedStage
      };
      this.customersByPlannedStages[`planned-stage-${plannedStage.id}`].customers[`customer-${customer.customerIndex}`] ||= customer;
      this.buildStagesByCustomers();
    },

    removeStageToCustomer (customer, plannedStage) {
      if (this.customersByPlannedStages[`planned-stage-${plannedStage.id}`]) {
        if (this.customersByPlannedStages[`planned-stage-${plannedStage.id}`].customers[`customer-${customer.customerIndex}`]) {
          delete this.customersByPlannedStages[`planned-stage-${plannedStage.id}`].customers[`customer-${customer.customerIndex}`];
        }
        if (Object.keys(this.customersByPlannedStages[`planned-stage-${plannedStage.id}`].customers).length === 0) {
          delete this.customersByPlannedStages[`planned-stage-${plannedStage.id}`].customers;
          delete this.customersByPlannedStages[`planned-stage-${plannedStage.id}`];
        }
      }
      this.buildStagesByCustomers();
    },

    buildStagesByCustomers () {
      const customers = {};
      const customersSelected = [];
      for (const plannedStageIndex in this.customersByPlannedStages) {
        const plannedStage = this.customersByPlannedStages[plannedStageIndex];
        for (const customerInStage in plannedStage.customers) {
          const customer = plannedStage.customers[customerInStage];
          customers[`customer-${customer.customerIndex}`] ||= {
            customer,
            plannedStages: []
          }
          customers[`customer-${customer.customerIndex}`].plannedStages.push(plannedStage.plannedStage);
          customersSelected.push(customer.customerIndex);
        }
      }
      const flatterCustomers = [];
      for (const customer in customers) {
        flatterCustomers.push(customers[customer]);
      }
      this.allCustomersIsPlanned = customersSelected.filter((val, ind, arr) => arr.indexOf(val) === ind).length === this.customers.length
      this.stagesByCustomers = flatterCustomers;
    },

    swipeStep (type = 'next') {
      for (const stepIndex in this.steps) {
        if (this.currentStep === this.steps[stepIndex]) {
          const index = parseInt(stepIndex);
          this.currentStep = this.steps[(type === 'next') ? index + 1 : index - 1];
          if (type === 'previous') {
            setTimeout(() => { this.scrollToTop(); }, 100)
          }
          return;
        }
      }
    },

    addToBasket () {
      this.loadingAddToCard = true;
      const data = {
        planned_stages: []
      };

      for (const stagesByCustomer of this.stagesByCustomers) {
        const customer = stagesByCustomer.customer
        for (const plannedStage of stagesByCustomer.plannedStages) {
          data.planned_stages.push(
              {
                customer: {
                  firstname: customer.firstname,
                  lastname: customer.lastname,
                  date_of_birth: customer.date_of_birth,
                },
                planned_stage_id: plannedStage.id
              }
          )
        }
      }

      store
          .dispatch("cart/addPlannedStages", data)
          .then(() => {
            this.addToBasketErrors = null;
            document.location.href = this.osvConfig.paths.cartProduct;
          })
          .catch((err) => {
            this.loadingAddToCard = false;
            this.addToBasketErrors = { event: 'OsvAlert_ErrorFromApi', err: err, object: 'planned_stage' };
          })
          .finally(() => {});
    },

    scrollToTop () {
      document.querySelector('osv-stages-planner').scrollIntoView({ behavior: 'smooth' });
    },

    goToSummary () {
      this.$nextTick(() => {
        this.$refs['stageSummary'].scrollIntoView({ behavior: 'smooth' });
      })
    }
  }
}
</script>

<style lang="scss" src="../assets/styles/buefy/base.scss" />

<style lang="scss">
.stages-customer-and-levels {
  list-style: disc;
  padding-left: 15px;
}
.planned-stages-list {
  .start-stage-summary-indicator {
    margin-top: -50px;
    padding-top: 50px;
  }
  .planned-stages-summary-title {
    .media-content {
      overflow: hidden;
    }
    .icon {
      float: right;
      margin-top: 5px;
    }
    &.is-sticky-summary {
      position: sticky;
      bottom: 7px;
      cursor: pointer;
      transition: box-shadow 0.1s;
      &:hover {
        box-shadow: 0 .5em 1.5em -.125em rgba(10,10,10,.25),0 0 0 1px rgba(10,10,10,.02);
      }
    }
  }
}
</style>
